<template>
  <div id="login" class="mainBody">
    <div @click="$router.push('/')" style="cursor:pointer;" class="page_head">
      <img width="5%" src="../../../assets/img/topLog2.png">
    </div>
    <div class="page_body">
      <div class="main_block">
        <div class="bg_block"></div>
        <div class="content_block">
          <ul class="tab_block">
            <li class="selected">注册</li>
          </ul>
          <div class="input_block">
            <div>昵称</div>
            <input type="text" placeholder="请输入昵称" v-model="postData.nickName"/>
          </div>
          <div class="input_block">
            <div>手机</div>
            <input type="tel" maxlength="11" placeholder="请输入手机号" v-model="postData.mobile"/>
          </div>
          <div class="input_block">
            <div>密码</div>
            <input type="password" placeholder="请输入密码" v-model="postData.password"/>
          </div>
          <div class="input_block">
            <div>验证码</div>
            <input type="text" maxlength="6" placeholder="请输入验证码" v-model="postData.verifyCode"/>
            <span class="c_p" @click="getVerify">{{verifyBtn}}</span>
          </div>
          <button class="loginButton" @click="register()">注册</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let count = 60
let timer = null
export default {
  name: 'login',
  data () { // 所有的数据都写在里面
    return {
      postData: {
        mobile: '',
        password: '',
        verifyCode: '',
        nickName: ''
      },
      verifyBtn: '获取验证码'
    }
  },
  created () {

  },
  destroyed () {
  },
  mounted () {
  },
  methods: {
    changeTab (curr) {
      if (curr !== this.postData.type) {
        this.postData.type = curr
      }
    },
    register () {
      this.$axiox.post('/baigang/auth/register', this.postData).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '注册成功',
          stayTime: 5
        })
        this.$router.push('login')
      })
    },
    getVerify () {
      this.verifyBtn = count + 's'
      if (timer === null) {
        this.$axiox.get('/baigang/auth/sendRegisterVerifyCode/' + this.postData.mobile).then(msg => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '验证码发送成功',
            stayTime: 5
          })
        })
        timer = setInterval(() => {
          count--
          this.verifyBtn = count + 's'
          if (count <= 0) {
            clearInterval(timer)
            this.verifyBtn = '获取验证码'
            count = 60
            timer = null
          }
        }, 1000)
      }
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/login/register.vue